'use strict';

module.exports = {
    consentDataKey: 'consentData'
};